import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { Insured } from '@/modules/Insured/interfaces/insured'
import { showErrors } from '@/utils/snack'
import { ApolloResponse } from '@/interfaces/apollo'
import { dateTimeToDisplay, dateToDisplay, dateToNow } from '@/utils/dateTime'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import InsuredDetailDetail from '@/modules/Insured/views/detail.vue'
import AppTabs from '@/components/AppTabs.vue'
import AppDialog from '@/components/AppDialog.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppCheckbox from '@/components/AppCheckbox.vue'
import AppRadio from '@/components/AppRadio.vue'
import RecordTypesHandler from '@/mixins/record-types'
import { getInsured } from '@/modules/Insured/gql/insured.gql'

import InsuredDialog from '@/modules/Insured/scripts/insured-dialog'

@Component({
  components: {
    AppBreadcrumbs,
    InsuredDetailDetail,
    AppTabs,
    AppDialog,
    AppTextSearch,
    AppCheckbox,
    AppRadio
  }
})

export default class InsuredDetail extends mixins(InsuredDialog, RecordTypesHandler) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Insured'
    }
  ]

  insured: Insured | null = null

  tabActive = 0
  tabItems = [
    {
      title: 'Details',
      route: 'InsuredDetailDetail'
    },
    {
      title: 'Additional',
      route: 'InsuredDetailAdditional'
    }
  ]

  disableConfirm = false

  recordTypeIndex = 0

  initState = true

  get tabTitles () {
    return this.tabItems.map(item => item.title)
  }

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay
  dateToNow = dateToNow

  mounted () {
    const { name } = this.$route
    const index = this.$R.findIndex((item: any) => item.route === name)(this.tabItems)
    this.tabActive = index
    this.getInsured()
  }

  @Watch('$route.params.id')
  onRouteParamUpdate (val: string) {
    this.getInsured()
  }

  async getInsured () {
    const insuredId = Number(this.$route.params.id)
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getInsured,
        variables: {
          insuredId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.insured = result.data.getInsured as Insured

      if (this.initState) {
        this.breadcrumbs.push({
          text: `${this.insured.name}`
        })
        this.initState = false
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  clickTabHandler (index: number) {
    const item = this.tabItems[index]
    if (item.route && item.route !== this.$route.name) {
      this.$router.push({
        name: item.route
      })
    }
  }

  async deleteInsuredConfirm () {
    await this.deleteInsuredPost()
    this.$router.go(-1)
  }
}
